import { Directive, OnDestroy, OnInit } from '@angular/core';
import { AbstractItemComponent } from '@df/catalog-ui/abstract-item.component';
import { Store } from '@df/catalog/store/store';

@Directive()
export class StoreComponentDef<T extends Store = Store> extends AbstractItemComponent<T> implements OnInit, OnDestroy {
    override verbosity = 1;

    override canDetach = true;

    type = Store.type;
}
